import { useRouter } from 'next/router';

const useShowMap = () => {
  const {
    query: { params },
  } = useRouter();

  const showMap = params && params[0] === 'map';

  return showMap;
};

export default useShowMap;
